import { render } from "./culturalTax.vue?vue&type=template&id=1ef67e76&scoped=true"
import script from "./culturalTax.vue?vue&type=script&lang=js"
export * from "./culturalTax.vue?vue&type=script&lang=js"

import "./culturalTax.vue?vue&type=style&index=0&id=1ef67e76&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef67e76"]])

export default __exports__